export enum ButtonTextStyles {
	REGULAR = 'Regular',
	MEDIUM = 'Medium',
	BOLD = 'Bold'
}

export enum ButtonStyles {
	PRIMARY = 'Primary',
	PRIMARY_HOLLOW = 'PrimaryHollow',
	SECONDARY = 'Secondary',
	TERTIARY = 'Tertiary',
	QUATERNARY = 'Quaternary',
	TERTIARY_BLUE = 'TertiaryBlue',
	DANGER = 'Danger',
	DARK = 'Dark',
	OUTLINE_PRIMARY = 'OutlinePrimary',
	OUTLINE_QUATERNARY = 'OutlineQuaternary',
	OUTLINE_DARK = 'OutlineDark',
	OUTLINE_GREEN = 'GreenOutLine',
	DECLINE_PRIMARY = 'DeclinePrimary',
	OUTLINE_BLUE = 'OutlineBlue',
	DEFAULT = 'Default',
	DEFAULT_BG = 'DefaultBg',
	DROPDOWN = 'Dropdown',
	ROUND = 'Round',
	HOLLOW = 'Hollow',
	LightGrey= 'LightGrey'
}

export enum ButtonSizes {
	WIDE = 'Wide',
	SMALL = 'Small',
	BIG = 'Big',
	UNSET = 'Unset'
}
